import Button from './Button';
import { ButtonProps } from './Button.interface';
export { Button };
export type { ButtonProps };